import PropTypes from "prop-types";

import { TOOLTIP } from "rtr-constants";

const PLACEMENTS = Object.keys(TOOLTIP.PLACEMENTS).map(placement => TOOLTIP.PLACEMENTS[placement]);
export const tooltipPlacementPropType = PropTypes.oneOf(PLACEMENTS);
